<template>
    <div class="education-wrapper">
        <div class="education-header">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/schooladmin/index' }"
                    >教务管理</el-breadcrumb-item
                >
                <el-breadcrumb-item>评委管理</el-breadcrumb-item>
            </el-breadcrumb>
            <el-button class="btn-blue" @click="addBtn">创建评委</el-button>
        </div>
        <el-table
            :data="teacherList"
            border
            style="width: 100%; margin-top: 20px; flex: 1"
            height="1%"
            size="medium"
            :header-cell-style="{
                fontWeight: 'normal',
                height: '60px',
                color: '#13131B',
                background: '#F2F3FA',
            }"
            :cell-style="{ fontSize: '14px', color: '#343441' }"
        >
            <el-table-column prop="name" align="center" label="评委名称"></el-table-column>
            <el-table-column prop="username" align="center" label="账号"></el-table-column>
            <el-table-column align="center" label="头像">
                <template slot-scope="scope">
                    <div class="school-logo">
                        <img
                            :src="
                                scope.row.headimgurl
                                    ? scope.row.headimgurl
                                    : require('../../../assets/images/user_img.png')
                            "
                            alt=""
                        />
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-link :underline="false" class="link-blue" @click="editBtn(scope.row)"
                        >编辑</el-link
                    >
                    <el-link :underline="false" type="danger" @click="delBtn(scope.row.id)"
                        >删除</el-link
                    >
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            class="pager-center"
            style="margin-top: 10px"
            :current-page="listPages.currentPageNum"
            :page-size="listPages.eachPageNum"
            :total="listPages.total"
            layout="prev, pager, next, jumper"
            @current-change="pagesCurrentChange"
        >
        </el-pagination>

        <!--        添加编辑弹窗-->
        <el-dialog
            :title="dialogTitle"
            :visible.sync="addDialog"
            width="500px"
            custom-class="dialog-blue"
            @close="resetForm()"
            @opened="openDialog"
            :close-on-click-modal="false"
        >
            <el-form
                :model="addForm"
                ref="addForm"
                :rules="addRules"
                label-position="right"
                label-width="100px"
            >
                <el-form-item label="评委名称" prop="name">
                    <el-input
                        v-model="addForm.name"
                        ref="cursorInput"
                        autocomplete="off"
                        placeholder="2-20字"
                    ></el-input>
                </el-form-item>
                <el-form-item label="账号" prop="username">
                    <el-input
                        v-model="addForm.username"
                        autocomplete="off"
                        placeholder="4-20字"
                    ></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password" v-if="distinguishBtn === 'add'">
                    <el-input
                        v-model="addForm.password"
                        auto-complete="new-password"
                        minlength="6"
                        maxlength="20"
                        show-password
                        placeholder="6-20字"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="重置密码"
                    prop="updatePassword"
                    v-else-if="distinguishBtn === 'edit'"
                >
                    <el-input
                        v-model="addForm.password"
                        auto-complete="new-password"
                        minlength="6"
                        maxlength="20"
                        show-password
                        placeholder="6-20字"
                    ></el-input>
                </el-form-item>
                <el-form-item label="头像" style="margin-bottom: 0">
                    <el-upload
                        class="logo-uploader"
                        :action="uploadCover"
                        :headers="headersParams"
                        name="file"
                        :show-file-list="false"
                        :on-success="handleCoverSuccess"
                        :before-upload="beforeCoverUpload"
                    >
                        <img v-if="imgSrc" :src="imgSrc" class="logo-cover" />
                        <i v-else class="el-icon-plus logo-uploader-icon"></i>
                    </el-upload>
                    <span class="school-prompt"
                        >建议尺寸：200*200；格式为.jpg 或 .jpeg 或 .png</span
                    >
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="text-align: center">
                <el-button size="medium" class="btn-blue" @click="addToForm('addForm')"
                    >确 定</el-button
                >
                <el-button size="medium" @click="addDialog = false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            teacherList: [],
            listPages: {
                currentPageNum: 1,
                eachPageNum: 10,
                total: 0,
            },
            // S 添加弹窗
            dialogTitle: '',
            addDialog: false,
            distinguishBtn: '',
            addForm: {
                id: '',
                name: '',
                username: '',
                password: '',
                headimgurl: '',
            },
            addRules: {
                name: [
                    { required: true, message: '请输入评委名称', trigger: 'blur' },
                    { min: 2, max: 20, message: '长度在 2 到 20 个字', trigger: 'blur' },
                ],
                username: [
                    { required: true, message: '请输入评委账号', trigger: 'blur' },
                    { min: 4, max: 20, message: '长度在 4 到 20 个字', trigger: 'blur' },
                ],
                password: [
                    { required: true, message: '请输入评委密码', trigger: 'blur' },
                    { min: 6, max: 20, message: '长度在 6 到 20 个字', trigger: 'blur' },
                ],
                updatePassword: [
                    { min: 6, max: 20, message: '长度在 6 到 20 个字', trigger: 'blur' },
                ],
            },
            // E 添加弹窗
            // S 上传图片需要
            uploadCover: this.$api.judgesAdminUploadHead,
            headersParams: {
                Authorization: localStorage.getItem('token'),
            },
            imgSrc: null,
            // E 上传图片需要
            role: Number(localStorage.getItem('role')),
        };
    },
    mounted() {
        this.getTeacherList();
    },
    methods: {
        // 获取教师列表
        getTeacherList() {
            let params = {
                paging: 1,
                page: this.listPages.currentPageNum,
                pageSize: this.listPages.eachPageNum,
            };
            this.$http.axiosGetBy(this.$api.judgesAdminList, params, res => {
                if (res.code === 200) {
                    this.teacherList = res.data.data;
                    this.listPages.total = res.data.total;
                    if (this.listPages.total !== 0 && this.teacherList.length === 0) {
                        this.listPages.currentPageNum--;
                        this.getTeacherList();
                    }
                } else {
                    this.$message.warning(res.msg);
                }
            });
        },
        // 切换分页
        pagesCurrentChange(val) {
            this.listPages.currentPageNum = val;
            this.getTeacherList();
        },
        // 打开弹窗光标
        openDialog() {
            this.$refs.cursorInput.focus();
        },
        // 添加
        addBtn() {
            this.dialogTitle = '创建评委';
            this.distinguishBtn = 'add';
            this.addDialog = true;
        },
        // 编辑
        editBtn(row) {
            this.$http.axiosGetBy(this.$api.judgesAdminList, { id: row.id }, res => {
                if (res.code === 200) {
                    this.addForm.headimgurl = res.data.headimgurl; // 无域名
                    this.imgSrc = res.data.headimgscr; // 有域名
                    // this.imgSrc = res.data.headimgurl // 无域名
                }
            });
            this.addForm.id = row.id;
            this.addForm.name = row.name;
            this.addForm.username = row.username;
            // this.addForm.headimgurl = row.headimgurl // 无域名
            // this.imgSrc = row.headimgurl // 有域名
            this.dialogTitle = '编辑评委';
            this.distinguishBtn = 'edit';
            this.addDialog = true;
        },
        // start 上传图片
        beforeCoverUpload(file) {
            const isImg =
                file.name.toLowerCase().endsWith('.jpg') ||
                file.name.toLowerCase().endsWith('.jpeg') ||
                file.name.toLowerCase().endsWith('.png');
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isImg) {
                this.$message.error('上传图片只能是 jpg 或 jpeg 或 png 格式!');
                return false;
            }
            if (!isLt2M) {
                this.$message.error('上传头像大小不能超过 2MB!');
            }
            return isImg && isLt2M;
        },
        handleCoverSuccess(res, file) {
            if (res.code === 200) {
                this.imgSrc = res.data.src; // 有域名
                this.addForm.headimgurl = res.data.url; //无域名
                this.$message.success('头像上传成功');
            } else {
                this.$message.error('头像上传失败，请稍后再试~');
            }
        },
        // end 上传图片
        // 添加表单确定
        addToForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    if (this.distinguishBtn === 'add') {
                        let formData = new FormData();
                        formData.append('name', this.addForm.name);
                        formData.append('username', this.addForm.username);
                        formData.append('password', this.addForm.password);
                        formData.append('headimgurl', this.addForm.headimgurl);
                        this.$http.axiosPost(this.$api.judgesAdminAdd, formData, res => {
                            if (res.code === 200) {
                                this.$message.success(res.msg);
                                this.getTeacherList();
                                this.addDialog = false;
                                this.resetForm();
                            } else {
                                this.$message.warning(res.msg);
                            }
                        });
                    } else if (this.distinguishBtn === 'edit') {
                        let formData = new FormData();
                        formData.append('name', this.addForm.name);
                        formData.append('username', this.addForm.username);
                        formData.append('headimgurl', this.addForm.headimgurl);
                        formData.append('id', this.addForm.id);
                        if (this.addForm.password) {
                            formData.append('password', this.addForm.password);
                        }
                        this.$http.axiosPost(this.$api.judgesAdminUpdate, formData, res => {
                            if (res.code === 200) {
                                this.$message.success(res.msg);
                                this.getTeacherList();
                                this.addDialog = false;
                                this.resetForm();
                            } else {
                                this.$message.warning(res.msg);
                            }
                        });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 删除
        delBtn(id) {
            this.$confirm('是否删除该评委，删除完将无法恢复', '提示消息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                confirmButtonClass: 'btn-blue',
                type: 'warning',
            })
                .then(() => {
                    this.$http.axiosPost(
                        this.$api.judgesAdminDel,
                        { id: id },
                        res => {
                            if (res.code === 200) {
                                this.$message.success(res.msg);
                                this.getTeacherList();
                            } else {
                                this.$message.warning(res.msg);
                            }
                        },
                        err => {
                            console.log(err);
                        }
                    );
                })
                .catch(() => {
                    this.$message.info('已取消删除');
                });
        },
        // 重置表单
        resetForm() {
            this.addForm = {
                id: '',
                name: '',
                username: '',
                password: '',
                headimgurl: '',
            };
            this.imgSrc = null;
        },
    },
};
</script>

<style scoped lang="scss">
.education-wrapper {
    padding: 30px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .education-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .el-breadcrumb {
            line-height: 40px;
        }
    }
}
.el-link + .el-link {
    margin-left: 10px;
}
.school-logo {
    width: 40px;
    height: 40px;
    overflow: hidden;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    img {
        max-width: 100%;
        max-height: 100%;
    }
}
.logo-uploader {
    width: 100px;
    height: 100px;
    border: 1px solid #ddd;
    ::v-deep .el-upload {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .logo-cover {
        display: block;
        max-width: 100%;
        max-height: 100%;
    }
    .logo-uploader-icon {
        color: #ccc;
        font-size: 24px;
    }
}
.school-prompt {
    color: #f56c6c;
}
</style>
